<template>
  <div>
    <van-cell-group class="no-border no-back">
      <van-field label="输入券码" input-align="right" placeholder="请输入输入券码" type="text" v-model="form.cardNo"></van-field>
    </van-cell-group>
    <van-cell-group class="no-border no-back flex-centers">
      <!-- <van-field label="输入车牌号" placeholder="请输入输入车牌号" type="text" v-model="form.carNo"></van-field> -->
      <van-field
        label="车牌号"
        input-align="right"
        placeholder="请输入车牌号"
        type="text"
        v-model="form.carNo"
      >
        <div slot="label" class="flex-area">
          <span class="text-bold">车牌号</span>
          <span class="arrow-area" @click="show=true">
            <i class="text">{{areaText}}</i>
            <van-icon name="arrow-down" />
          </span>
          <span class="arrow-area" @click="showNo=true">
            <i class="text">{{areaNo}}</i>
            <van-icon name="arrow-down" />
          </span>
        </div>
      </van-field>
    </van-cell-group>
    <van-cell-group class="no-border no-back">
      <van-field label="手机号" placeholder="请输入您的手机号" input-align="right" :readonly="beMobile" type="text" v-model="form.mobile"></van-field>
    </van-cell-group>
    <van-cell-group class="no-border no-back flex-button" v-if="!beMobile">
      <van-field label="验证码" placeholder="请输入验证码" input-align="right" type="text" v-model="form.smsCode"></van-field>
      <van-button
        type="primary"
        color="#6495FE"
        @click="getCatcha"
        :disabled="downTime>0"
      >{{btnCodeText}}</van-button>
    </van-cell-group>
    <van-button class="large-button" type="primary" @click="handleSure" :loading="loading">确定兑换</van-button>
    <div class="txt">兑换成功后，点击公众号菜单栏【嘛雀会员】-点击【个人中心】-点击【优惠券】即可查看使用。</div>
    <!-- 车牌区域 -->
    <van-popup v-model="show" position="bottom" :style="{ height: '50%' }">
      <div class="area-code">
        <van-button @click="getAreaText(v)" v-for="v in carData" :key="v" type="default">{{v}}</van-button>
      </div>
    </van-popup>
    <!-- 车牌字母 -->
    <van-popup v-model="showNo" position="bottom" :style="{ height: '50%' }">
      <div class="area-code">
        <van-button @click="getAreaNo(v)" v-for="v in carNo" :key="v" type="default">{{v}}</van-button>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { carTitle, carNum, carFirstTitle } from "@/api/carData";
import { mPattern, carParttern } from "@/assets/js/rules";
export default {
  name: "GetCard",
  data () {
    return {
      form: {
        mobile: '',
        smsCode: '',
        cardNo: '',
        carNo: ''
      },
      carNoStr: '',
      areaText: '',
      areaNo: '',
      downTime: 0,
      show: false,
      showNo: false,
      loading: false,
      beMobile: false,
      carData: Array.from(carTitle),
      carNo: Array.from(carNum)
    };
  },
  watch: {
    "form.carNo" (t) {
      if (t) {
        this.form.carNo = t.toUpperCase();
      }
    },
    "form.cardNo" (t) {
      if (t) {
        this.form.cardNo = t.toUpperCase();
      }
    }
  },
  computed: {
    btnCodeText () {
      return this.downTime > 0 ? this.downTime + "s后重新获取" : "获取验证码";
    }
  },
  async mounted () {
    if (this.getStore('addrObj') && this.getStore('addrObj').province !== '') {
      let province = this.getStore('addrObj').province;
      carFirstTitle.filter(it => {
        if (it.name === province) {
          this.areaText = it.title;
        }
      });
    }
    let userInfo = await this.request("/user/user/get", {});
    if (userInfo.code === 0) {
      if (userInfo.data.mobile) {
        this.form.mobile = userInfo.data.mobile;
        this.beMobile = true;
      }
    } else {
      console.log(userInfo);
    }
    console.log(userInfo);
    // let res = await this.getUser();
    // console.log(res);
    // if (res.data.mobile !== '') {
    //   this.go(`/ToCard?id=${this.$route.query.id}`);
    // }
  },
  methods: {
    // 获取验证码
    async getCatcha () {
      let param = this.form;
      if (!param.mobile) {
        this.$error("请输入手机号");
      } else if (!mPattern.test(param.mobile)) {
        this.$error("手机号格式有误");
      } else {
        let url = "/user/user/bindMobile";
        let res = await this.request(url, {
          mobile: this.form.mobile
        });
        if (res.code === 0) {
          this.downTime = 60;
          let that = this;
          that.countDown(that);
        } else {
          this.$error("获取失败：" + res.msg);
        }
      }
    },
    // 获取区域车牌
    getAreaText (v) {
      this.areaText = v;
      this.show = false;
    },
    // 获取车牌字母
    getAreaNo (v) {
      this.areaNo = v;
      this.showNo = false;
    },
    // 提交表单
    async handleSure () {
      this.carNoStr = this.areaText + this.areaNo + this.form.carNo;
      if (this.form.mobile === '') {
        this.$error('请输入手机号');
        return;
      }
      if (!mPattern.test(this.form.mobile)) {
        this.$error("手机号格式有误");
        return;
      }
      if (this.form.smsCode === '' && !this.beMobile) {
        this.$error('请输入验证码');
        return;
      }
      if (this.form.cardNo === '') {
        this.$error('请输入券码');
        return;
      }
      if (this.form.carNo === '' || this.areaNo === '' || this.areaText === '') {
        this.$error('请输入车牌号');
        return;
      }
      if (!carParttern.test(this.carNoStr)) {
        this.$error("车牌号信息错误");
        return;
      }
      this.loading = true;
      if (!this.beMobile) {
        let res = await this.request("/user/user/bindUserOfMobile", {
          mobile: this.form.mobile,
          smsCode: this.form.smsCode
        });
        console.log(res);
        if (res.code === 0) {
          this.getCard();
        } else {
          this.loading = false;
        }
      } else {
          this.getCard();
      }
    },
    async getCard() {
      try {
        let result = await this.request("/user/user/convertCard", {
          cardNo: this.form.cardNo,
          carNo: this.carNoStr
        });
        if (result.code === 0) {
          this.loading = false;
          this.$error('兑换成功');
          setTimeout(() => {
            // this.goBack();
            this.go(`/useCard?id=${result.data.id}`);
          }, 1000);
        } else {
          console.log(result.msg);
          this.$error(result.msg);
          setTimeout(() => {
            this.goBack();
            // this.go(`/useCard?id=${result.data.id}`);
          }, 1000);
          this.loading = false;
        }
      } catch (error) {
          console.log(error);
      }
    },
    // 定时器
    countDown (that) {
      if (this.downTime === 0) {
      } else {
        this.downTime--;
        // 循环调用
        setTimeout(function () {
          that.countDown(that);
        }, 1000);
      }
    }
  }
};
</script>

<style lang="less" scoped>
@import "~@/assets/css/style";
.large-button {
  width: 80%;
  display: block;
  margin: 20px auto;
}
.flex-button {
  .flex-center();
  /deep/.van-button {
    padding: 0;
    background: transparent !important;
    color: #0096ff !important;
    border: 0;
    line-height: 1;
    width: 150px;
  }
}
.txt{
    font-size: 14px;
    color: red;
    width: 80%;
    margin: 0 auto;
}

.area-code {
  display: flex;
  flex-wrap: wrap;
  margin: 2.5%/2;
  .van-button {
    min-width: 10%;
    max-width: 10%;
    margin: 2.5%/2;
    padding: 0;
    line-height: 1;
    flex: 1;
  }
}
.flex-centers {
  .flex-center();
  /deep/.van-field__label {
    width: 150px;
  }
  /deep/.van-cell__value {
    padding: 0 10px;
  }
}
.flex-area {
  border-right: 1px solid #e6e6e6;
  .flex-center();
  justify-content: flex-start;
  white-space: nowrap;
  .text-bold {
    padding-right: 35px;
  }
  .arrow-area {
    margin-right: 15px;
    .flex-center();
    i {
      color: #3296fa;
      font-size: 13px;
      &.van-icon {
        font-size: 12px;
      }
    }
    .text {
      padding-right: 2px;
      font-style: normal;
    }
  }
}
</style>